export function normalizeVin(value) {
  return value.toUpperCase().replace(/\s/g, "");
}

export function validateVin(vin) {
  if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
    return "Enter a 17-character VIN using letters and numbers. VINs do not use I, O or Q.";
  }
  return "";
}

export async function decodeVin(vin, signal) {
  const response = await fetch(
    `https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/${encodeURIComponent(vin)}?format=json`,
    { signal, credentials: "omit", referrerPolicy: "no-referrer" }
  );
  if (!response.ok) throw new Error("The vehicle database is unavailable. Please try again shortly.");
  const payload = await response.json();
  const data = payload.Results?.[0];
  if (!data || (!data.Make && !data.Model && !data.ModelYear)) {
    throw new Error("No vehicle details were found. Check the VIN and try again.");
  }
  return data;
}
